export default __webpack_public_path__ + "static/media/gallery-wip-grenade cap_09.147dbb43.jpg";